module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-message"
  }, [_c('div', {
    staticClass: "message-bloc"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("orders.message.textMessage")))]), _vm._v(" "), _c('div', {
    staticClass: "message-groupe"
  }, [_c('div', {
    staticClass: "groupe message-groupe-user"
  }, [_c('span', [_vm._v(_vm._s(_vm.rem3rchUser.user.initial))])]), _vm._v(" "), _c('div', {
    staticClass: "groupe message-groupe-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageContent),
      expression: "messageContent"
    }],
    class: {
      emptyMsg: _vm.classError
    },
    attrs: {
      "rows": "6"
    },
    domProps: {
      "value": (_vm.messageContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messageContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "groupe message-groupe-btn"
  }, [_c('button', {
    staticClass: "btn btn-send",
    on: {
      "click": function($event) {
        _vm.sendMessageOrder();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.message.btnSen")))])])])]), _vm._v(" "), (_vm.order.purchaseOrderNumber) ? _c('div', {
    staticClass: "order-ref"
  }, [_c('span', {
    staticClass: "order-ref-label"
  }, [_vm._v(_vm._s(_vm.$t("orders.labelPurchase")) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "purchaseOrderNumber"
  }, [_vm._v(_vm._s(_vm.order.purchaseOrderNumber))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-history"
  }, [_c('h2', {
    staticClass: "order-history-title"
  }, [_vm._v(_vm._s(_vm.$t("orders.message.history")))]), _vm._v(" "), _vm._l((_vm.dataCommentToSorted), function(comment) {
    return (_vm.dataCommentToSorted) ? _c('div', {
      key: comment.id,
      staticClass: "order-history-message"
    }, [_c('div', [_c('div', {
      staticClass: "order-bloc order-history-message-user"
    }, [(comment.createdBy.initial) ? _c('span', {
      class: {
        statusMessage: comment.message === null
      }
    }, [_vm._v(_vm._s(comment.createdBy.initial))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "order-bloc order-history-message-content"
    }, [_c('div', {
      staticClass: "created-message"
    }, [_c('span', {
      staticClass: "user-history"
    }, [_vm._v("\n                            " + _vm._s(comment.createdBy.initial) + " (" + _vm._s(comment.createdBy.firstname) + " " + _vm._s(comment.createdBy.lastname) + ")\n                        ")]), _vm._v(" "), (comment.orderStatus) ? _c('span', {
      staticClass: "historyTypeStatus"
    }, [_vm._v("\n                            " + _vm._s(_vm.getTranslate(comment.orderStatus.terms.name)) + "\n                            "), (comment.orderStatus.terms.reference_status === 'shipping_cost_added') ? _c('span', {
      staticClass: "infos"
    }, [_vm._v("\n                                : " + _vm._s(_vm._f("CurrencyCustomPipe")(comment.data.shippingCost, "en-US", _vm.currencyBrand.shortName)) + " by\n                                " + _vm._s(comment.data.shippingMethod) + "\n                            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (comment.orderAction) ? _c('span', {
      staticClass: "infos-history"
    }, [_vm._v("\n                            " + _vm._s(comment.content.terms) + " : "), _c('span', {
      directives: [{
        name: "html-safe",
        rawName: "v-html-safe",
        value: (comment.content.infos),
        expression: "comment.content.infos"
      }],
      staticClass: "infos"
    })]) : _vm._e()]), _vm._v(" "), (comment.message) ? _c('p', {
      staticClass: "message"
    }, [_vm._v(_vm._s(comment.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "order-bloc order-history-message-created-date"
    }, [_c('span', [_vm._v(_vm._s(_vm.convertGmtToLocal(new Date(comment.createdAt)).toLocaleString()))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.timeAgo(comment.interval)))])])])]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c4a3b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderMain/OrderMessage.vue
// module id = 3207
// module chunks = 0